'use strict';

goog.provide("Ntry.JrPlayground");

Ntry.jrPlayground = function() {
    var that = this;
    this._view = Ntry.interfaceManager.getDom('ntryPlayground');
    this.createDom();
    this.isResizing = false;
    this._currentCnt = 0;

    this.code = null;
    this.availableCode = null;
};

(function(p){

    p.createDom = function () {
        var ce = Ntry.createElement;
        var parent = this._view;
        var colTop = ce('div', parent, null, 'jrRightColTop');
        this._currentBlockNumber = ce('div', colTop, null, 'jrCurrentBlockNumber');
        this._goalBlockNumber = ce('div', colTop, null, 'jrGoalBlockNumber');
        this._goalBlockNumber.setAttribute("id", "jrGoalBlockNumber");
        this.topbackground = ce('div', colTop, null, 'topbackground');

        var info = ce('div', parent, null, 'jrRightColInfo');
        ce('div', info, null, 'jrRightColInfoLeft').
            innerHTML = Lang.Menus.block_box;
        ce('div', info, null, 'jrRightColInfoRight').
            innerHTML = Lang.Menus.block_assembly;

        var playground = ce('div', parent, null, 'ntryPlayground');
        this._blockMenu = ce('div', playground, 'jrPlaygroundBlockMenu',
                             'jrPlaygroundBlockMenu', 'blockMenuWorkspace', 'selectDisable');
        this._workspace = ce('div', playground, 'jrPlaygroundWorkspace', 'jrPlaygroundWorkspace');

        this.blockBg = ce('div', this._blockMenu, null, 'blockBackground');
    };

    p.update = function() {
        if (!this.code) this.findCode();
        if (!this.availableCode) this.findAvailableCode();
    };

    p.findCode = function() {
        var em = Ntry.entityManager;
        var entities = em.getEntitiesByComponent(
            Ntry.STATIC.CODE);

        var entity;
        for (var key in entities)
            var entity = entities[key];

        if (entity)
            this.code = em.getComponent(
                entity.id, Ntry.STATIC.CODE).code;
            if (this.code) {
                Entry.mainWorkspace.board.changeCode(this.code);
                var thread = this.code.getThreads()[0];
                this.code.changeEvent.attach(this, function() {
                    this._updateGoals(thread);
                });
                this._updateGoals(thread);
                this.code.executeEndEvent.attach(this, function() {
                    Ntry.dispatchEvent("executeEnd",
                               Ntry.STATIC.COMPLETE);
                });
            }
    };

    p.findAvailableCode = function() {
        var code = Ntry.configManager.getConfig("availableCode");
        if (code) {
            this.availableCode = new Entry.Code(code);
            if (this.availableCode)
                Entry.mainWorkspace.changeBlockMenuCode(this.availableCode);
        }
    };

    p.loadConfig = function () {
        Entry.toast = new Entry.Toast();

        this._generateGoals(Ntry.configManager.getConfig("limitBlockCnt"));

        Entry.mainWorkspace = new Entry.Workspace(
            {
                'blockMenu': {
                    dom: 'jrPlaygroundBlockMenu',
                    align: Ntry.configManager.getConfig("blockMenuAlign")
                },
                'board': {
                    dom: "jrPlaygroundWorkspace"
                }
            }
        );
        Entry.Utils.bindBlockExecuteFocusEvents();
    };

    p._generateGoals = function(count) {
        var parent = this._goalBlockNumber;
        this._goalBlocks = [];
        for(var i=0; i< count; i++) {
            var element = Ntry.createElement(
                'div', null, null, 'jrGoalBlockNumberSub');
            this._goalBlocks.push(element);
            parent.appendChild(element);
        }
    };

    p._updateGoals = function (thread) {
        var count = thread.countBlock() - 1;
        var goals = this._goalBlocks;
        var goalLength = this._goalBlocks.length;

        this._goalBlockNumber.removeClass('blinkStar');

        var overflow = goalLength < count;

        var className = !overflow ? 'jrGoalBlockAdd' : 'jrGoalFulled';
        for (var i=0; i<goals.length; i++) {
            var goal = goals[i];
            goal.removeClass('jrGoalBlockAdd');
            goal.removeClass('jrGoalFulled');
            goal.removeClass('blinkStar');
            if (i < count) goal.addClass(className);
        }
        if (overflow) {
            var elem = this._goalBlockNumber;
            elem.addClass('blinkStar');
            $(elem).bind('oanimationend animationend webkitAnimationEnd', function() {
                elem.removeClass('blinkStar');
            });
        }
    };

})(Ntry.jrPlayground.prototype);


